import {
    Action,
    Namespace,
    StoreName,
    StoreProps
} from '../../../services/proto/ServerStorage/utils';

export const keyParams: StoreProps = {
    nameSpace: Namespace.System,
    action: Action.Onload,
    storage: StoreName.Announcements,
    hasWildcard: false
};

export const priSupprtUrl = 'https://support.priority-software.com/';

// Release notes links - should be updated with each new version (see EP-53259 ticket in Jira for example)
export const verReleaseNotesEn = 'en/kb/LBI2500521/English';
export const verReleaseNotesHe = 'he/kb/LBI2500522/Hebrew';
